const _backup = {};

const instance = {
  set(key, value) {
    value = value == null ? undefined : JSON.stringify(value);

    if (value == null) {
      this.del(key);

      return;
    }

    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      _backup[key] = value;
    }
  },

  get(key) {
    let value;

    try {
      value = window.localStorage.getItem(key);
    } catch (e) {
      value = _backup[key];
    }

    return value == null ? value : JSON.parse(value);
  },

  del(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      delete _backup[key];
    }
  },

  // Force localstorage thread to finish async
  asyncSet(key, value) {
    return new Promise((resolve) => {
      this.set(key, value);
      resolve();
    });
  },
};

export default instance;
